import { useMessages } from '@app/context/MessageContext';
import { useNavigation } from '@app/hooks/useNavigation';
import { useUserWithCompany } from '@app/hooks/useUserWithCompany';
import { Button, NotificationModal } from '@components/ui';
import { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export function CelloReminderMessage() {
  const { t } = useTranslation();
  const { celloreminder } = useMessages();
  const { navigation } = useNavigation();
  const { whitelabelConfig } = useUserWithCompany();

  const avatarImage = whitelabelConfig?.avatarB64 && whitelabelConfig.avatarB64 !== 'unset'
    ? whitelabelConfig.avatarB64
    : '/assets/images/dieter_schaf_cape.svg';

  // Compute milestone for specific thresholds: 1%, 25%, 75%
  const milestoneKey = useMemo(() => {
    const progress = navigation?.progress ?? 0;
    if (progress >= 0.75) return '75';
    if (progress >= 0.25) return '25';
    if (progress >= 0.05) return '01';
    return undefined; // below 5%
  }, [navigation?.progress]);

  const lastMilestoneRef = useRef<string | undefined>(undefined);
  useEffect(() => {
    // Set a distinct context when crossing a new milestone (5/25/75)
    if (milestoneKey && lastMilestoneRef.current !== milestoneKey) {
      lastMilestoneRef.current = milestoneKey;
      celloreminder.setContext({ name: 'celloreminder', milestone: milestoneKey });
    }
  }, [milestoneKey, celloreminder]);

  return (
    <NotificationModal open={celloreminder.isOpen} onClose={celloreminder.close} unsolicited>
      <div className="flex flex-col p-[30px] text-center">
        <div className="bg-primary-root -mx-[40px] px-9 py-7 -mt-[40px] flex flex-col text-center gap-4">
          <img src={avatarImage} alt="Info" className="h-[250px] w-auto max-w-full self-center object-contain" />
          <span className="text-white font-medium text-lg">Datenschutz mit Dieter = Datenschutz für alle!</span>
        </div>
        <p className="mt-5 font-semibold">Du kommst gut voran! Andere können das auch...</p>
        <p>
          Wenn du auf das Geschenk oben rechts klickst, erhältst du sofort deinen persönlichen Empfehlungslink, bereit
          zum Teilen!
        </p>
        <p className="text-left">So funktioniert’s:</p>
        <div className="text-left flex flex-col gap-2">
          <div className="flex gap-3 items-center">
            <span>✅</span>
            <span> Deine Freunde erhalten 25 % Rabatt auf Dieter im ersten Vertragsjahr.</span>
          </div>
          <div className="flex gap-3 items-center">
            <span>✅</span>
            <span> Für deine erste erfolgreiche Empfehlung erhältst du sofort 20 €.</span>
          </div>
          <div className="flex gap-3 items-center">
            <span>✅</span>
            <span> Du bekommst 15 % des Umsatzes für die Vertragsdauer – bis zu 1.000 € pro Empfehlung</span>
          </div>
        </div>
        <p className="font-semibold mt-5">Teilen lohnt sich!</p>

        <div className="pointer-events-auto bg-white my-5">
          <div className="flex flex-col items-center text-center gap-5">
            <Button onClick={celloreminder.close} data-testid="button-close">
              Das hört sich verdammt gut an!
            </Button>
          </div>
        </div>
      </div>
    </NotificationModal>
  );
}
